import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
import SearchDropdown from "../../../../../../search/seatchDropdown";

function EditIntegration({ chimeraserv, user }) {
  const location = useLocation();
  const data = location.state?.data || {};
  console.log("EditIntegration data:", data);

  // Format date for input[type="date"] - expects YYYY-MM-DD
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  const [form, setForm] = useState({
    venueId: { value: data.venueId || "", state: null },
    apiKey: { value: data.apiKey || "", state: null },
    expiryDate: {
      value: formatDateForInput(data.expiryDate) || "",
      state: null,
    },
    message: { value: "", state: null },
    state: false,
  });

  const headers = {
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const checker = (state) => {
    const check = { icon: "check-circle", style: "null" };
    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }
    return check;
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: { value, state: true },
      message: { value: "", state: null },
    }));
  };

  const handleReset = () => {
    setForm({
      venueId: { value: data.venueId || "", state: null },
      apiKey: { value: data.apiKey || "", state: null },
      expiryDate: {
        value: formatDateForInput(data.expiryDate) || "",
        state: null,
      },
      message: { value: "", state: null },
      state: false,
    });
  };

  const isFormValid =
    form.venueId.value && form.apiKey.value && form.expiryDate.value;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;
    try {
      const UpdateResponse = await axios({
        method: "PUT",
        url: chimeraserv.urlMozrest + "/mozrest/apikey/" + data.venueId,
        headers: {
          Authorization: user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: {
          venueId: form.venueId.value,
          apiKey: form.apiKey.value,
          expiryDate: form.expiryDate.value,
        },
      });
      setForm((prev) => ({
        ...prev,
        message: { value: "Integration Updated Successfully!", state: true },
      }));
    } catch (error) {
      setForm((prev) => ({
        ...prev,
        message: {
          value: error.response?.data?.message || "Error updating integration",
          state: false,
        },
        state: false,
      }));
    }
  };

  return (
    <div className="custForm">
      <Helmet>
        <title>Edit Integration | Chimera Solutions | Insights</title>
      </Helmet>
      <div className="viewTitle">Edit Integration</div>
      <form onSubmit={handleSubmit} className="form">
        {form.message.value && (
          <div
            className={`alert ${
              form.message.state ? "alert-success" : "alert-error"
            }`}
            style={{
              padding: "10px 15px",
              marginBottom: "15px",
              borderRadius: "4px",
              backgroundColor: form.message.state ? "#d4edda" : "#f8d7da",
              color: form.message.state ? "#155724" : "#721c24",
              border: `1px solid ${form.message.state ? "#c3e6cb" : "#f5c6cb"}`,
            }}
          >
            <FontAwesomeIcon
              icon={[
                "fas",
                form.message.state ? "check-circle" : "exclamation-circle",
              ]}
              style={{ marginRight: "8px" }}
            />
            {form.message.value}
          </div>
        )}

        <div className="form-group">
          <label>
            Venue ID <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.venueId.state).style].join(" ")}
            icon={["fas", checker(form.venueId.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="venueId"
            value={form.venueId.value ?? ""}
            onChange={handleChange}
            placeholder="Enter Venue ID"
          />
        </div>
        <div className="form-group">
          <label>
            API Key <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.apiKey.state).style].join(" ")}
            icon={["fas", checker(form.apiKey.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="apiKey"
            value={form.apiKey.value ?? ""}
            onChange={handleChange}
            placeholder="Enter API Key"
          />
        </div>
        <div className="form-group">
          <label>
            Expiry Date <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.expiryDate.state).style].join(" ")}
            icon={["fas", checker(form.expiryDate.state).icon]}
          />
          <input
            type="date"
            className="form-control"
            name="expiryDate"
            value={form.expiryDate.value ?? ""}
            onChange={handleChange}
          />
        </div>

        <div className="form-actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!isFormValid}
          >
            Update
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn btn-primary reset"
          >
            Reset
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditIntegration;
